import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

function MesafeliSatisSozlesmesi() {
  return (
    <Container maxWidth="lg" sx={{ mt: { xs: '76px', sm: '84px' }, mb: 4 }}>
      <Paper elevation={0} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ mb: 4 }}>
          MESAFELİ SATIŞ SÖZLEŞMESİ
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          1. TARAFLAR
        </Typography>
        <Typography paragraph>
          İşbu Sözleşme aşağıdaki taraflar arasında aşağıda belirtilen hüküm ve şartlar çerçevesinde imzalanmıştır.
        </Typography>
        <Typography paragraph>
          A.'ALICI' ; (sözleşmede bundan sonra "ALICI" olarak anılacaktır)
        </Typography>
        <Typography paragraph>
          B.'KAYLA BUTİK' ; (sözleşmede bundan sonra "SATICI" olarak anılacaktır)
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          2. TANIMLAR
        </Typography>
        <Typography paragraph>
          İşbu sözleşmenin uygulanmasında ve yorumlanmasında aşağıda yazılı terimler karşılarındaki yazılı açıklamaları ifade edeceklerdir.
        </Typography>
        <Typography paragraph>
          BAKAN: Gümrük ve Ticaret Bakanı'nı,
        </Typography>
        <Typography paragraph>
          BAKANLIK: Gümrük ve Ticaret Bakanlığı'nı,
        </Typography>
        <Typography paragraph>
          KANUN: 6502 sayılı Tüketicinin Korunması Hakkında Kanun'u,
        </Typography>
        <Typography paragraph>
          YÖNETMELİK: Mesafeli Sözleşmeler Yönetmeliği'ni (RG:27.11.2014/29188),
        </Typography>
        <Typography paragraph>
          HİZMET: Bir ücret veya menfaat karşılığında yapılan ya da yapılması taahhüt edilen mal sağlama dışındaki her türlü tüketici işleminin konusunu,
        </Typography>
        <Typography paragraph>
          SATICI: Ticari veya mesleki faaliyetleri kapsamında tüketiciye mal sunan veya mal sunan adına veya hesabına hareket eden şirketi,
        </Typography>
        <Typography paragraph>
          ALICI: Bir mal veya hizmeti ticari veya mesleki olmayan amaçlarla edinen, kullanan veya yararlanan gerçek ya da tüzel kişiyi,
        </Typography>
        <Typography paragraph>
          SİTE: SATICI'ya ait internet sitesini,
        </Typography>
        <Typography paragraph>
          SİPARİŞ VEREN: Bir mal veya hizmeti SATICI'ya ait internet sitesi üzerinden talep eden gerçek ya da tüzel kişiyi,
        </Typography>
        <Typography paragraph>
          TARAFLAR: SATICI ve ALICI'yı,
        </Typography>
        <Typography paragraph>
          SÖZLEŞME: SATICI ve ALICI arasında akdedilen işbu sözleşmeyi,
        </Typography>
        <Typography paragraph>
          MAL: Alışverişe konu olan taşınır eşyayı ve elektronik ortamda kullanılmak üzere hazırlanan yazılım, ses, görüntü ve benzeri gayri maddi malları ifade eder.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          3. KONU
        </Typography>
        <Typography paragraph>
          İşbu Sözleşme, ALICI'nın, SATICI'ya ait internet sitesi üzerinden elektronik ortamda siparişini verdiği aşağıda nitelikleri ve satış fiyatı belirtilen ürünün satışı ve teslimi ile ilgili olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmelere Dair Yönetmelik hükümleri gereğince tarafların hak ve yükümlülüklerini düzenler.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          4. SATICI BİLGİLERİ
        </Typography>
        <Typography paragraph>
          Ünvanı: KAYLA BUTİK
        </Typography>
        <Typography paragraph>
          Adres: İstanbul, Türkiye
        </Typography>
        <Typography paragraph>
          Telefon: +90 (531) 694 97 44
        </Typography>
        <Typography paragraph>
          E-posta: info@kaylabutik.com
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          5. ALICI BİLGİLERİ
        </Typography>
        <Typography paragraph>
          Teslim edilecek kişi, teslimat adresi, telefon ve e-posta bilgileri sipariş formunda ALICI tarafından belirtilecektir.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          6. SİPARİŞ VEREN KİŞİ BİLGİLERİ
        </Typography>
        <Typography paragraph>
          Sipariş veren kişi bilgileri, sipariş formunda ALICI tarafından belirtilecektir.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          7. SÖZLEŞME KONUSU ÜRÜN BİLGİLERİ
        </Typography>
        <Typography paragraph>
          7.1. Malın/Ürünlerin/Hizmetin temel özellikleri (türü, miktarı, marka/modeli, rengi, adedi) SATICI'ya ait internet sitesinde yayınlanmaktadır.
        </Typography>
        <Typography paragraph>
          7.2. Listelenen ve sitede ilan edilen fiyatlar satış fiyatıdır. İlan edilen fiyatlar ve vaatler güncelleme yapılana ve değiştirilene kadar geçerlidir. Süreli olarak ilan edilen fiyatlar ise belirtilen süre sonuna kadar geçerlidir.
        </Typography>
        <Typography paragraph>
          7.3. Ürün sevkiyat masrafı olan kargo ücreti ALICI tarafından ödenecektir.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          8. FATURA BİLGİLERİ
        </Typography>
        <Typography paragraph>
          Fatura sipariş teslimatı sırasında fatura adresine sipariş ile birlikte teslim edilecektir.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          9. GENEL HÜKÜMLER
        </Typography>
        <Typography paragraph>
          9.1. ALICI, SATICI'ya ait internet sitesinde sözleşme konusu ürünün temel nitelikleri, satış fiyatı ve ödeme şekli ile teslimata ilişkin ön bilgileri okuyup, bilgi sahibi olduğunu, elektronik ortamda gerekli teyidi verdiğini kabul, beyan ve taahhüt eder.
        </Typography>
        <Typography paragraph>
          9.2. Sözleşme konusu her bir ürün, 30 günlük yasal süreyi aşmamak kaydı ile ALICI'nın yerleşim yeri uzaklığına bağlı olarak internet sitesindeki ön bilgiler kısmında belirtilen süre zarfında ALICI veya ALICI'nın gösterdiği adresteki kişi ve/veya kuruluşa teslim edilir.
        </Typography>
        <Typography paragraph>
          9.3. SATICI, sözleşme konusu ürünü eksiksiz, siparişte belirtilen niteliklere uygun ve varsa garanti belgeleri, kullanım kılavuzları işin gereği olan bilgi ve belgeler ile teslim etmeyi, her türlü ayıptan arî olarak yasal mevzuat gereklerine göre sağlam, standartlara uygun bir şekilde işi doğruluk ve dürüstlük esasları dâhilinde ifa etmeyi, hizmet kalitesini koruyup yükseltmeyi, işin ifası sırasında gerekli dikkat ve özeni göstermeyi, ihtiyat ve öngörü ile hareket etmeyi kabul, beyan ve taahhüt eder.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          10. TEMERRÜT HALİ VE HUKUKİ SONUÇLARI
        </Typography>
        <Typography paragraph>
          ALICI, ödeme işlemlerini kredi kartı ile yaptığı durumda temerrüde düştüğü takdirde, kart sahibi banka ile arasındaki kredi kartı sözleşmesi çerçevesinde faiz ödeyeceğini ve bankaya karşı sorumlu olacağını kabul, beyan ve taahhüt eder.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          11. YETKİLİ MAHKEME
        </Typography>
        <Typography paragraph>
          İşbu sözleşmeden doğan uyuşmazlıklarda şikayet ve itirazlar, Tüketici Mahkemeleri ve Tüketici Hakem Heyetleri'nde görülecektir.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          12. YÜRÜRLÜK
        </Typography>
        <Typography paragraph>
          ALICI, Site üzerinden verdiği siparişe ait ödemeyi gerçekleştirdiğinde işbu sözleşmenin tüm şartlarını kabul etmiş sayılır. SATICI, siparişin gerçekleşmesi öncesinde işbu sözleşmenin sitede ALICI tarafından okunup kabul edildiğine dair onay alacak şekilde gerekli yazılımsal düzenlemeleri yapmakla yükümlüdür.
        </Typography>
      </Paper>
    </Container>
  );
}

export default MesafeliSatisSozlesmesi; 